import styled from "@emotion/styled";
import {getImageUrl} from "../../context/ApplicationContextProvider";

export const RIGHT_ARROW_TEXT = ({children, className}) => {
    const RightArrowText = styled.div((props) => ({
        fontSize: props.theme.font_size.f17,
        color: props.theme.colors.dg2,
        height: "1.5em",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        "& > .arrow-right-icon": {
            width: "1em",
            height: "1em",
            background: `url(${getImageUrl("image/common/ic_arrow_right_grey.png")}) center center/contain no-repeat`,
            transform: "translateY(2px)",
        },
    }));

    return (
        <RightArrowText className={className}>
            <span>{children}</span>
            <div className="arrow-right-icon" />
        </RightArrowText>
    );
};
